/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteCustomPriceListMutationVariables = Exact<{
  id: string;
}>;


export type DeleteCustomPriceListMutation = { delete_custom_price_list_by_pk: { id: string } | null };


export const DeleteCustomPriceListDocument = /*#__PURE__*/ gql`
    mutation DeleteCustomPriceList($id: uuid!) {
  delete_custom_price_list_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteCustomPriceListMutationFn = Apollo.MutationFunction<DeleteCustomPriceListMutation, DeleteCustomPriceListMutationVariables>;

/**
 * __useDeleteCustomPriceListMutation__
 *
 * To run a mutation, you first call `useDeleteCustomPriceListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomPriceListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomPriceListMutation, { data, loading, error }] = useDeleteCustomPriceListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomPriceListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomPriceListMutation, DeleteCustomPriceListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomPriceListMutation, DeleteCustomPriceListMutationVariables>(DeleteCustomPriceListDocument, options);
      }
export type DeleteCustomPriceListMutationHookResult = ReturnType<typeof useDeleteCustomPriceListMutation>;
export type DeleteCustomPriceListMutationResult = Apollo.MutationResult<DeleteCustomPriceListMutation>;
export type DeleteCustomPriceListMutationOptions = Apollo.BaseMutationOptions<DeleteCustomPriceListMutation, DeleteCustomPriceListMutationVariables>;